"use client";

import { PATH } from "@/constants/path";
import { useAnalytics } from "@/hooks/useAnalytics";
import { FunnelEvent, UserEvent } from "@/types/analytics";
import { cn } from "@/utils/cn";

import Button from "./Button";

interface CTASectionProps {
  className?: string;
}

function CTASection({ className }: CTASectionProps) {
  const { trackUserEvent, trackFunnelEvent } = useAnalytics();

  const handleContactClick = () => {
    trackUserEvent(UserEvent.PAGE_NAVIGATED, {
      destination: "request_page",
      source: "cta_section_contact_button"
    });
  };

  const handleDownloadClick = () => {
    trackFunnelEvent(FunnelEvent.CONTENT_DOWNLOADED, {
      content_type: "company_introduction",
      location: "cta_section"
    });
  };

  return (
    <section
      className={cn(
        "flex items-center justify-center px-side py-32",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-10">
        <div className="text-center text-30 font-semibold">
          <span className="whitespace-nowrap">우리 기업에</span>{" "}
          <span className="whitespace-nowrap">꼭 필요한 핵심 인재,</span>{" "}
          <br className="hidden tablet:block" />
          <span className="whitespace-nowrap">숨어있던 인재들을</span>{" "}
          <span className="whitespace-nowrap">지금 바로 만나보세요.</span>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          <Button href={PATH.REQUEST} onClick={handleContactClick}>
            문의하기
          </Button>
          <Button
            color="gray"
            href={PATH.COMPANY_INTRO}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDownloadClick}
          >
            회사 소개서 다운받기
          </Button>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
